import { render, staticRenderFns } from "./kyc-certification-detail.vue?vue&type=template&id=0e667a09&scoped=true&"
import script from "./kyc-certification-detail.vue?vue&type=script&lang=js&"
export * from "./kyc-certification-detail.vue?vue&type=script&lang=js&"
import style0 from "./kyc-certification-detail.vue?vue&type=style&index=0&id=0e667a09&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e667a09",
  null
  
)

export default component.exports